import type { TheraProfile } from "./supabase";

const PROFILE_CACHE_KEY = "thera-approved-profile-v1";
const validStatuses = new Set(["pending", "approved", "rejected", "suspended"]);

function validProfile(value: unknown): value is TheraProfile {
  if (!value || typeof value !== "object") return false;
  const profile = value as Partial<TheraProfile>;
  return typeof profile.id === "string"
    && typeof profile.email === "string"
    && typeof profile.first_names === "string"
    && typeof profile.last_names === "string"
    && (profile.role === "member" || profile.role === "admin")
    && typeof profile.status === "string"
    && validStatuses.has(profile.status);
}

export function loadCachedProfile(userId?: string) {
  try {
    const value = JSON.parse(localStorage.getItem(PROFILE_CACHE_KEY) ?? "null") as unknown;
    if (!validProfile(value) || (userId && value.id !== userId)) return null;
    return value;
  } catch {
    return null;
  }
}

export function saveCachedProfile(profile: TheraProfile) {
  try {
    localStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify(profile));
  } catch {
    // El modo offline sigue disponible durante la sesión aunque el navegador
    // haya bloqueado almacenamiento persistente.
  }
}

export function clearCachedProfile() {
  try {
    localStorage.removeItem(PROFILE_CACHE_KEY);
  } catch {
    // Sin acción adicional: el cierre remoto sigue protegido por Supabase.
  }
}
